const { createConstant } = require("../../helpers");

const service = "market/order";

module.exports = {
  ALL_ORDERS_LIST: createConstant(service, "ALL_ORDERS_LIST"),
  ALL_ORDERS_LIST_SUCCESS: createConstant(service, "ALL_ORDERS_LIST_SUCCESS"),
  ALL_ORDERS_LIST_ERROR: createConstant(service, "ALL_ORDERS_LIST_ERROR"),
  ALL_ORDERS_LIST_RESET: createConstant(service, "ALL_ORDERS_LIST_RESET"),

  TOPAY_ORDERS_LIST: createConstant(service, "TOPAY_ORDERS_LIST"),
  TOPAY_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "TOPAY_ORDERS_LIST_SUCCESS"
  ),
  TOPAY_ORDERS_LIST_ERROR: createConstant(service, "TOPAY_ORDERS_LIST_ERROR"),
  TOPAY_ORDERS_LIST_RESET: createConstant(service, "TOPAY_ORDERS_LIST_RESET"),

  TOPACK_ORDERS_LIST: createConstant(service, "TOPACK_ORDERS_LIST"),
  TOPACK_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "TOPACK_ORDERS_LIST_SUCCESS"
  ),
  TOPACK_ORDERS_LIST_ERROR: createConstant(service, "TOPACK_ORDERS_LIST_ERROR"),
  TOPACK_ORDERS_LIST_RESET: createConstant(service, "TOPACK_ORDERS_LIST_RESET"),

  TOSHIP_ORDERS_LIST: createConstant(service, "TOSHIP_ORDERS_LIST"),
  TOSHIP_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "TOSHIP_ORDERS_LIST_SUCCESS"
  ),
  TOSHIP_ORDERS_LIST_ERROR: createConstant(service, "TOSHIP_ORDERS_LIST_ERROR"),
  TOSHIP_ORDERS_LIST_RESET: createConstant(service, "TOSHIP_ORDERS_LIST_RESET"),

  TORECEIVE_ORDERS_LIST: createConstant(service, "TORECEIVE_ORDERS_LIST"),
  TORECEIVE_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "TORECEIVE_ORDERS_LIST_SUCCESS"
  ),
  TORECEIVE_ORDERS_LIST_ERROR: createConstant(
    service,
    "TORECEIVE_ORDERS_LIST_ERROR"
  ),
  TORECEIVE_ORDERS_LIST_RESET: createConstant(
    service,
    "TORECEIVE_ORDERS_LIST_RESET"
  ),

  TOCOMPLETE_ORDERS_LIST: createConstant(service, "TOCOMPLETE_ORDERS_LIST"),
  TOCOMPLETE_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "TOCOMPLETE_ORDERS_LIST_SUCCESS"
  ),
  TOCOMPLETE_ORDERS_LIST_ERROR: createConstant(
    service,
    "TOCOMPLETE_ORDERS_LIST_ERROR"
  ),
  TOCOMPLETE_ORDERS_LIST_RESET: createConstant(
    service,
    "TOCOMPLETE_ORDERS_LIST_RESET"
  ),

  GET_ORDER_DETAILS: createConstant(service, "GET_ORDER_DETAILS"),
  GET_ORDER_DETAILS_SUCCESS: createConstant(
    service,
    "GET_ORDER_DETAILS_SUCCESS"
  ),
  GET_ORDER_DETAILS_ERROR: createConstant(service, "GET_ORDER_DETAILS_ERROR"),
  GET_ORDER_DETAILS_RESET: createConstant(service, "GET_ORDER_DETAILS_RESET"),

  CANCEL_ORDERS: createConstant(service, "CANCEL_ORDERS"),
  CANCEL_ORDERS_SUCCESS: createConstant(service, "CANCEL_ORDERS_SUCCESS"),
  CANCEL_ORDERS_ERROR: createConstant(service, "CANCEL_ORDERS_ERROR"),
  CANCEL_ORDERS_RESET: createConstant(service, "CANCEL_ORDERS_RESET"),

  RETURN_ORDERS_LIST: createConstant(service, "RECEIVED_ORDERS"),
  RETURN_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "RETURN_ORDERS_LIST_SUCCESS"
  ),
  RETURN_ORDERS_LIST_ERROR: createConstant(service, "RETURN_ORDERS_LIST_ERROR"),
  RETURN_ORDERS_LIST_RESET: createConstant(service, "RETURN_ORDERS_LIST_RESET"),

  CANCEL_THE_ORDER: createConstant(service, "CANCEL_THE_ORDER"),
  CANCEL_THE_ORDER_SUCCESS: createConstant(service, "CANCEL_THE_ORDER_SUCCESS"),
  CANCEL_THE_ORDER_ERROR: createConstant(service, "CANCEL_THE_ORDER_ERROR"),
  CANCEL_THE_ORDER_RESET: createConstant(service, "CANCEL_THE_ORDER_RESET"),

  RECEIVED_ORDERS: createConstant(service, "RECEIVED_ORDERS"),
  RECEIVED_ORDERS_SUCCESS: createConstant(service, "RECEIVED_ORDERS_SUCCESS"),
  RECEIVED_ORDERS_ERROR: createConstant(service, "RECEIVED_ORDERS_ERROR"),
  RECEIVED_ORDERS_RESET: createConstant(service, "RECEIVED_ORDERS_RESET"),

  TO_ACCEPT_ORDERS_LIST: createConstant(service, "TO_ACCEPT_ORDERS_LIST"),
  TO_ACCEPT_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "TO_ACCEPT_ORDERS_LIST_SUCCESS"
  ),
  TO_ACCEPT_ORDERS_LIST_ERROR: createConstant(
    service,
    "TO_ACCEPT_ORDERS_LIST_ERROR"
  ),
  TO_ACCEPT_ORDERS_LIST_RESET: createConstant(
    service,
    "TO_ACCEPT_ORDERS_LIST_RESET"
  ),

  TO_REDEEM_ORDERS_LIST: createConstant(service, "TO_REDEEM_ORDERS_LIST"),
  TO_REDEEM_ORDERS_LIST_SUCCESS: createConstant(
    service,
    "TO_REDEEM_ORDERS_LIST_SUCCESS"
  ),
  TO_REDEEM_ORDERS_LIST_ERROR: createConstant(
    service,
    "TO_REDEEM_ORDERS_LIST_ERROR"
  ),
  TO_REDEEM_ORDERS_LIST_RESET: createConstant(
    service,
    "TO_REDEEM_ORDERS_LIST_RESET"
  ),
};
